import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipelineSwitcherComponent } from './pipeline-switcher.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [PipelineSwitcherComponent],
  providers: [],
  exports: [PipelineSwitcherComponent],
  imports: [CommonModule, MatIconModule, MatButtonToggleModule, TranslateModule],
})
export class PipelineSwitcherModule {}
